module.exports = __webpack_public_path__ + "static/media/standard_operating_procedures.c7660d25.pdf";